import React, { Component } from 'react';

import '../assets/css/style.css';
import {Switch, Route, Link, withRouter} from 'react-router-dom';

import Tap from "./Tap";
import TapInstructions from './TapInstructions';
import End from "./End";
import PuzzleInstructions from "./PuzzleInstructions";
import Puzzle from "./Puzzle";
import Quiz from "./Quiz";
import QuizInstructions from "./QuizInstructions";
import Home from "./Home";
import SongSelection from "./SongSelection";
import Fact from "./Fact";
import PageNotFound from "./PageNotFound";
import Background from "./Background";
import ReactGA from 'react-ga';

import {DATA, TESTING_MODE} from '../config';

class App extends Component {

    constructor() {
        super();

        ReactGA.initialize('UA-65256381-2');

        this.state = {
            selectedSong: TESTING_MODE ? DATA.songs[0] : null,
            currentFactIndex: 0,
            finalScore: 0,
            finalScorePercentage: 0,
            isReplay: false
        };
    }

    setSelectedSong(song) {
        this.setState({
            selectedSong: song,
            currentFactIndex: 0
        });
    }

    incrementFactCounter() {
        this.setState({
            currentFactIndex: this.state.currentFactIndex+1
        });
    }

    setFinalScores(score, percentage) {
        this.setState({
            finalScore: score,
            finalScorePercentage: percentage
        });
    }

    checkForSelectedSong() {
        if(!this.state.selectedSong) {
            this.props.history.push("/");
            return false;
        } else {
            return true;
        }
    }

    setReplay() {
        this.setState({
            isReplay: true
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            ReactGA.pageview(this.props.location.pathname);
        }
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route exact path="/songs"
                           render={() => {
                               return <SongSelection songs={DATA.songs}
                                                     setSelectedSong={(song) => this.setSelectedSong(song)}
                                      />;
                           }}
                    />
                    <Route exact path="/fact"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <Fact factIndex={this.state.currentFactIndex}
                                                fact={this.state.selectedSong.facts[this.state.currentFactIndex]}
                                                incrementFactCounter={() => this.incrementFactCounter()}
                                                fullSong={this.state.selectedSong.mediaURLFull}
                                                songTitle={this.state.selectedSong.name}
                                                songId={this.state.selectedSong.id}
                                                isReplay={this.state.isReplay}
                                   />;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/quiz/instructions"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <QuizInstructions songTitle={this.state.selectedSong.name}/>;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/quiz"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <Quiz questions={this.state.selectedSong.questions}
                                                songTitle={this.state.selectedSong.name}
                                                isReplay={this.state.isReplay}
                                   />;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/puzzle/instructions"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <PuzzleInstructions songTitle={this.state.selectedSong.name}/>;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/puzzle"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <Puzzle puzzleClips={this.state.selectedSong.puzzleClips}
                                                  fullSong={this.state.selectedSong.mediaURLFull}
                                                  songTitle={this.state.selectedSong.name}
                                                  isReplay={this.state.isReplay}
                                   />;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/tap/instructions"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <TapInstructions songTitle={this.state.selectedSong.name}/>;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/tap"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <Tap tapTimingsLeft={this.state.selectedSong.tapTimingsLeft}
                                               tapTimingsRight={this.state.selectedSong.tapTimingsRight}
                                               audio={this.state.selectedSong.mediaURLCountdown}
                                               setFinalScores={(score, percentage) => {
                                                   this.setFinalScores(score, percentage)
                                               }}
                                               songTitle={this.state.selectedSong.name}
                                               songId={this.state.selectedSong.id}
                                               isReplay={this.state.isReplay}
                                   />;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/end"
                           render={() => {
                               if(this.checkForSelectedSong()) {
                                   return <End finalScore={this.state.finalScore}
                                               finalScorePercentage={this.state.finalScorePercentage}
                                               songTitle={this.state.selectedSong.name}
                                               setReplay={() => {this.setReplay()}}
                                               isReplay={this.state.isReplay}
                                   />;
                               }
                               return null;
                           }}
                    />
                    <Route exact path="/" component={Home}/>
                    <Route path="*" component={PageNotFound}/>
                </Switch>

                <Background/>

                {
                    TESTING_MODE &&
                    <ul>
                        <li><Link to="/">Start</Link></li>
                        <li><Link to="/songs">Songs</Link></li>
                        <li><Link to="/fact">Fact</Link></li>
                        <li><Link to="/quiz/instructions">Quiz Instructions</Link></li>
                        <li><Link to="/quiz">Quiz</Link></li>
                        <li><Link to="/puzzle/instructions">Puzzle Instructions</Link></li>
                        <li><Link to="/puzzle">Puzzle</Link></li>
                        <li><Link to="/tap/instructions">Tap Instructions</Link></li>
                        <li><Link to="/tap">Tap</Link></li>
                        <li><Link to="/end">End</Link></li>
                        <li><Link to="asdf">404</Link></li>
                    </ul>
                }
            </div>
      );
    }
}
export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js